<template>
  <div>
    <c-dashboard v-if="exibirParaFinanceiros"></c-dashboard>
    <div v-else class="home text-xs-center">
      <v-layout row wrap class="mt-5">
        <v-flex>
          <img src="https://storage.googleapis.com/catho-repositorio/logo/logo.png" width="30%" />
          <div style="text-align: center;" class="mt-3 display-1 font-weight-thin">
            Bem vindo ao Sistema online para Pagamentos ao
            <br />Fornecedor e Colaborador
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Dashboard from "./dashboard/Dashboard.vue";
export default {
  name: "home",
  components: {
    "c-dashboard": Dashboard
  },
  computed: {
    ...mapState({
      loggedUser: state => state.loggedUser
    }),
    exibirParaFinanceiros() {
      let usuarioTemPapeis =
        this.loggedUser.papeis.filter(i => {
          if (
            i.nome == "APROVADOR_CONTABILIDADE" ||
            i.nome == "APROVADOR_FINANCEIRO" ||
            i.nome == "PROCURADOR"
          )
            return i.nome;
        }).length > 0;

      if (usuarioTemPapeis) return true;
      else return false;
    }
  }
};
</script>
